module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_AboutUs_VN.b6c7193d.webp";